import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    myReportsLoading: false,
    myReportsList: {
        data: [],
        allData: [],
        pageNo: 1,
      limit: 25,
        totalElements: 0,
        last: true,
  first: true,
    },
};

export const MyReportsReducerSlice = createSlice({
    name: 'myReportsReducer',
  initialState,
    reducers: {
        updateMyReportsLoading: (state, action) => {
      state.myReportsLoading = action.payload;
        },
        updateMyReportsList: (state, action) => {
     state.myReportsList = action.payload;
        },
        /**
         * Prepends a new report record to the top of `data` and `allData`
         * only if a record with the same `ID` does not already exist.
 * Payload: the new report object from the onCreateSPRODownloadReport subscription.
         */
        prependMyReport: (state, action) => {
            const newRecord = action.payload;
            if (!newRecord || !newRecord.ID) return;

      const alreadyExistsInData = Array.isArray(state.myReportsList.data) &&
          state.myReportsList.data.some((r) => String(r.ID) === String(newRecord.ID));

            if (!alreadyExistsInData) {
       state.myReportsList.data = [newRecord, ...(state.myReportsList.data || [])];
                state.myReportsList.totalElements = (state.myReportsList.totalElements || 0) + 1;
     }

     if (Array.isArray(state.myReportsList.allData)) {
     const alreadyExistsInAllData = state.myReportsList.allData.some(
            (r) => String(r.ID) === String(newRecord.ID)
            );
     if (!alreadyExistsInAllData) {
           state.myReportsList.allData = [newRecord, ...state.myReportsList.allData];
     }
  }
        },
    /**
    * Updates a single record in both `data` (current page) and `allData`
         * (full dataset) by matching on `ID`.
         * Payload: the updated report object received from the onUpdateSPRODownloadReport subscription.
         */
        updateSingleMyReport: (state, action) => {
          const updated = action.payload;
            if (!updated || !updated.ID) return;

    const patchArray = (arr) => {
       if (!Array.isArray(arr)) return arr;
  const idx = arr.findIndex((r) => String(r.ID) === String(updated.ID));
       if (idx !== -1) {
      arr[idx] = { ...arr[idx], ...updated };
      }
           return arr;
      };

            state.myReportsList.data = patchArray(state.myReportsList.data);
            if (state.myReportsList.allData) {
           state.myReportsList.allData = patchArray(state.myReportsList.allData);
            }
        },
        resetMyReportsState: (state) => {
      state.myReportsLoading = false;
     state.myReportsList = {
       data: [],
allData: [],
    pageNo: 1,
  limit: 25,
   totalElements: 0,
     last: true,
         first: true,
            };
        },
    },
});

export const {
    updateMyReportsLoading,
    updateMyReportsList,
    prependMyReport,
    updateSingleMyReport,
    resetMyReportsState,
} = MyReportsReducerSlice.actions;

// Selector
export const myReportsSelector = (state) => state.myReportsReducer;

export default MyReportsReducerSlice.reducer;
